export default {
  // 3-3
  GET_WORKAREA_COND(state, res) {
    state.workArea_facList = res.data.facs;
    state.workArea_locationList = res.data.locations;
    state.workArea_fabList = res.data.fabApporveList;
  },
  GET_WORKAREA_LIST(state, res) {
    const data = JSON.parse(JSON.stringify(res.data));
    data.forEach((e, index) => {
      e.index = index + 1;
    });
    state.workArea_all = data;
    state.workArea_allList = state.workArea_all.slice(0, 10);
  },

  GET_SIGNOFF_COND(state, res) {
    state.signoff_areaType = res.data.areaType;
  },
  GET_SECONDAREA_LIST(state, res) {
    state.signoff_secondAreaList = res.data;
  },
  GET_WORKER_LIST(state, res) {
    state.signoff_workerList = res.data;
  },
  GET_SIGNOFF_LIST(state, res) {
    const data = JSON.parse(JSON.stringify(res.data));
    data.forEach((e, index) => {
      e.index = index + 1;
      e.locInfo = `${e.ld2}/${e.ld4}/${e.floor}`;
    });
    state.signoff_all = data;
    state.signoff_allList = state.signoff_all.slice(0, 10);
  },
  GET_SIGNOFF_DETAIL(state, res) {
    state.signoff_detail = res.data;
  },

  // 3-4~3-5
  GET_ALL_FACLIST(state, res) {
    state.facList_all = res.data;
  },
  GET_ALL_ROOMLIST(state, res) {
    const data = JSON.parse(JSON.stringify(res.data));
    data.forEach((e, index) => {
      e.index = index + 1;
      e.locInfo = `${e.location_Description}(${e.location_E_Description})`;
      if (!e.sponsor) {
        e.empInfo = "無資料";
      } else {
        e.empInfo = `${e.emp_Name} (${e.sponsor}, ${e.emp_Email}) (${e.emp_Dept_Full_Name})`;
      }
    });
    state.room_all = data;
    state.room_allList = state.room_all.slice(0, 10);
  },

  GET_NONDUSTLESS_FABLIST(state, res) {
    state.nonDustless_fabList = res.data;
  },
  GET_DUSTLESS_FABLIST(state, res) {
    state.dustless_fabList = res.data;
  },

  // 3-6
  GET_HIGHRISK_LIST(state, res) {
    const data = JSON.parse(JSON.stringify(res.data));
    data.forEach((e, index) => {
      e.index = index + 1;
    });
    state.highrisk_all = data;
    state.highrisk_allList = state.highrisk_all.slice(0, 10);
  },

  // 3-12
  GET_CONTRACT_LIST(state, res) {
    const data = JSON.parse(JSON.stringify(res.data));
    data.forEach((e, index) => {
      e.index = index + 1;
      e.empInfo = `${e.emp_Name}(${e.emp_No})`;
    });
    state.contract_all = data;
    state.contract_allList = state.contract_all.slice(0, 10);
  },
};
